import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Math.css";

const PRACTICE_GAMES = [
  { path: "addition", label: "Addition", icon: "➕" },
  { path: "subtraction", label: "Subtraction", icon: "➖" },
  { path: "multiplication", label: "Multiplication", icon: "✖️" },
  { path: "division", label: "Division", icon: "➗" },
  { path: "geometry", label: "Geometry", icon: "📐" },
  { path: "metric-conversion", label: "Metric Conversion", icon: "🔄" },
  { path: "fraction", label: "Fraction", icon: "🔄" },

  // New
  { path: "trig-graph", label: "Trig Graph Practice", icon: "📈" },
  { path: "trigonometry", label: "Trigonometry", icon: "∠" },
  { path: "algebra", label: "Alebgra", icon:"🅰️"},
  { path: "wording-problem", label: "Wording Problem", icon:"🅰"},
  { path: "math-data-graph", label: "Data Graph Practice", icon:"🅰"},
];
function Math() {
  const [userGrade, setUserGrade] = useState(null);

  useEffect(() => {
    const userAge = parseInt(localStorage.getItem("userAge"), 10);
    if (userAge && userAge >= 6 && userAge <= 18) {
      setUserGrade(userAge - 5);
    }
  }, []);

  const gradeList = userGrade
    ? [<Link key={userGrade} to={`/math/grade${userGrade}`} className="math-grade-card">Grade {userGrade}</Link>]
    : [...Array(12)].map((_, index) => (
        <Link key={index + 1} to={`/math/grade${index + 1}`} className="math-grade-card">
          Grade {index + 1}
        </Link>
      ));

  // Split basic/advanced for grouping
  const BASIC_PRACTICE_GAMES = PRACTICE_GAMES.slice(0, 6);
  const ADVANCED_PRACTICE_GAMES = PRACTICE_GAMES.slice(6);

  return (
    <div className="play2learn-math">
      <h1 className="math-title">Math Lessons</h1>
      <p className="math-description">
        {userGrade ? `Showing content for Grade ${userGrade}` : "Select a grade to start learning:"}
      </p>

      <div className="math-grade-container">
        {gradeList}
      </div>

      {/* Basic Practice */}
      <h3 className="math-practice-heading">Or jump into a practice game:</h3>
      <div className="math-practice-container">
        {BASIC_PRACTICE_GAMES.map(({ path, label, icon }) => (
          <Link
            key={path}
            to={`/math/practice/${path}`}
            className="math-practice-btn"
          >
            {icon} {label}
          </Link>
        ))}
      </div>

      {/* Advanced Practice */}
      <h3 className="math-practice-heading" style={{marginTop: 18}}>Advanced Practice</h3>
      <div className="math-practice-container">
        {ADVANCED_PRACTICE_GAMES.map(({ path, label, icon }) => (
          <Link
            key={path}
            to={`/math/practice/${path}`}
            className="math-practice-btn"
          >
            {icon} {label}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Math;
